import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Facebook, Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { useLang } from "@/context/LanguageContext";
import { CONTACT, waLink } from "@/lib/contact";

export default function Footer() {
  const { t, tr } = useLang();
  const COLS = [
    { title: "VORNA", links: [
      { l: t("nav_catalog"), to: "/catalogo" }, { l: t("nav_athletes"), to: "/atletas" },
      { l: t("nav_about"), to: "/sobre-vorna" }, { l: t("nav_contact"), to: "/contacto" } ] },
    { title: tr("Catálogo", "Catalogue"), links: [
      { l: tr("Pantalonetas MMA", "MMA Shorts"), to: "/catalogo?category=mma-shorts" },
      { l: tr("Muay Thai", "Muay Thai"), to: "/catalogo?category=muay-thai-shorts" },
      { l: tr("Tops y Rashes", "Tops & Rash Guards"), to: "/catalogo?category=tops" },
      { l: tr("Conjuntos", "Sets"), to: "/catalogo?category=sets" } ] },
  ];
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-vorna-bg">
      <div className="mx-auto max-w-[1600px] px-5 lg:px-10 py-16 lg:py-24">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="col-span-2">
            <Logo imgClass="h-14" />
            <p className="mt-5 max-w-xs text-sm text-white/50 leading-relaxed">
              {tr("Marca ecuatoriana de deportes de combate. Productos para atletas de MMA, Jiu-Jitsu y grappling.",
                  "Ecuadorian combat-sports brand. Gear for MMA, Jiu-Jitsu and grappling athletes.")}
            </p>
            <div className="mt-6 flex gap-3">
              {[
                { href: CONTACT.instagram, icon: <Instagram className="h-5 w-5" />, test: "footer-instagram" },
                { href: waLink(""), icon: <MessageCircle className="h-5 w-5" />, test: "footer-whatsapp" },
                { href: CONTACT.facebook, icon: <Facebook className="h-5 w-5" />, test: "footer-facebook" },
                { href: `mailto:${CONTACT.email}`, icon: <Mail className="h-5 w-5" />, test: "footer-email" },
              ].map((s) => (
                <a key={s.test} data-testid={s.test} href={s.href} target="_blank" rel="noreferrer"
                  className="h-11 w-11 flex items-center justify-center border border-white/15 hover:bg-vorna-accent hover:border-vorna-accent transition-colors">{s.icon}</a>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="font-display text-sm uppercase tracking-widest text-white mb-5">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((li) => (
                  <li key={li.l}><Link to={li.to} className="text-sm text-white/50 hover:text-vorna-accent transition-colors">{li.l}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-display uppercase tracking-widest text-sm text-white/70">{CONTACT.city} 🇪🇨</p>
          <p className="text-xs text-white/30">© {new Date().getFullYear()} VORNA. {tr("Todos los derechos reservados.", "All rights reserved.")}</p>
        </div>
      </div>
    </footer>
  );
}
